import React from "react";

const PositionsTable = ({
  portfolio,
  formatCurrency,
  formatPercentage,
  closePosition,
  closingCoin,
  autonomousStatus,
}) => {
  return (
    <div className="mt-8">
      <div className="bg-gray-800 rounded-lg p-6">
        <h2 className="text-xl font-bold mb-4">Current Positions</h2>
        {portfolio?.positions && portfolio.positions.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="text-left py-2">Symbol</th>
                  <th className="text-left py-2">Side</th>
                  <th className="text-left py-2">Quantity</th>
                  <th className="text-left py-2">Avg Price</th>
                  <th className="text-left py-2">Current Price</th>
                  <th className="text-left py-2">Market Value</th>
                  <th className="text-left py-2">P&L</th>
                  <th className="text-left py-2">P&L %</th>
                  <th className="text-left py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {portfolio.positions.map((position, index) => {
                  const avgPrice = position.average_price || position.avg_price || position.entry_price || 0;
                  const currentPrice = position.current_price || position.currentPrice || 0;
                  const rawQuantity = position.quantity || 0;
                  const quantity = Math.abs(rawQuantity);
                  const side = position.side || (rawQuantity >= 0 ? 'LONG' : 'SHORT');
                  const marketValue = position.market_value || (quantity * currentPrice);
                  const coin = position.coin || position.symbol?.replace('-USD', '') || position.ticker?.replace('-USD', '');

                  let unrealizedPL = position.unrealized_pl || position.unrealized_pnl || position.pnl || 0;
                  let unrealizedPLPercent = position.unrealized_plpc || position.unrealized_pnl_pct || position.pnl_percent || 0;

                  if (!unrealizedPL && avgPrice > 0 && currentPrice > 0 && quantity > 0) {
                    if (side === 'SHORT') {
                      unrealizedPL = (avgPrice - currentPrice) * quantity;
                    } else {
                      unrealizedPL = (currentPrice - avgPrice) * quantity;
                    }
                  }

                  if (!unrealizedPLPercent && avgPrice > 0 && currentPrice > 0 && quantity > 0) {
                    const entryCost = avgPrice * quantity;
                    const leverage = position.leverage || 1;
                    unrealizedPLPercent = entryCost > 0 ? (unrealizedPL / entryCost) * 100 * leverage : 0;
                  }

                  return (
                    <tr key={`pos-${position.symbol || position.ticker}-${index}`} className="border-b border-gray-700">
                      <td className="py-2 font-semibold">{position.symbol || position.ticker}</td>
                      <td className={`py-2 font-semibold ${side === 'LONG' ? 'text-green-400' : 'text-red-400'}`}>
                        {side === 'LONG' ? 'LONG' : 'SHORT'}
                      </td>
                      <td className="py-2">{quantity.toFixed(4)}</td>
                      <td className="py-2">{avgPrice > 0 ? formatCurrency(avgPrice) : 'N/A'}</td>
                      <td className="py-2">{currentPrice > 0 ? formatCurrency(currentPrice) : formatCurrency(0)}</td>
                      <td className="py-2">{formatCurrency(marketValue)}</td>
                      <td className={`py-2 font-semibold ${unrealizedPL >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                        {formatCurrency(unrealizedPL)}
                      </td>
                      <td className={`py-2 font-semibold ${unrealizedPLPercent >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                        {formatPercentage(unrealizedPLPercent)}
                      </td>
                      <td className="py-2">
                        <div className="flex space-x-2">
                          <button
                            data-testid={`close-position-${coin}`}
                            onClick={() => closePosition(coin)}
                            disabled={closingCoin === coin}
                            className={`px-2 py-1 text-xs rounded transition-colors ${
                              closingCoin === coin
                                ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                                : 'bg-red-600 hover:bg-red-700 text-white'
                            }`}
                            title={`Close ${coin} position`}
                          >
                            {closingCoin === coin ? '...' : 'Close'}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="text-gray-400 mb-4">
              <p className="text-lg font-semibold mb-2">No Current Positions</p>
              <p className="text-sm">
                {autonomousStatus?.user_participating
                  ? 'System is active and monitoring for trading opportunities.'
                  : 'Click "Start Trading" to begin.'}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PositionsTable;
